<template>
  <v-card v-if="editMode || propertiesList.length > 0" variant="flat" class="mt-2 mb-2 mx-auto" style="max-width: 66%">
    <v-card-title class="text-subtitle-2 py-2 px-4 d-flex align-center">
      <span>{{ $t(editMode ? 'admin-resources.edit.properties.groupTitle' : 'admin-resources.filter.property.groupTitle') }}</span>
      <v-spacer />
      <v-btn v-if="editMode" icon size="small" variant="tonal" color="primary" @click="addSearchPropertyRow">
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </v-card-title>
    <v-divider />
    <v-card-text class="pa-2">
      <v-form ref="formRef">
        <resource-properties-edit-single-row
          v-for="property in propertiesList"
          :key="property.propertyCode"
          :allPropertiesDictionary="allPropertiesDictionary"
          :resourceProperty="property"
          :usedCodes="allUsedCodes"
          @filterRowRemoved="onFilterRowRemoved"
        />
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';
import type { ResourceDictPropertyValue, ResourceFilterPropertyValue } from '@/venit/services/model/techpubs-cms';
import ResourcePropertiesEditSingleRow from './resource-properties-edit-row-component.vue';

const props = defineProps<{
  allPropertiesDictionary: ResourceDictPropertyValue[];
  propertiesList: ResourceFilterPropertyValue[];
  editMode?: boolean;
}>();

const formRef = ref();

const allUsedCodes = computed(() => props.propertiesList.map(p => p.propertyCode).filter(Boolean) as string[]);

const onFilterRowRemoved = (filterProperty: ResourceFilterPropertyValue) => {
  const idx = props.propertiesList.findIndex(prop => prop === filterProperty);
  if (idx >= 0) {
    props.propertiesList.splice(idx, 1);
  }
};

const addSearchPropertyRow = () => {
  props.propertiesList.push({
    options: [],
    propertyCode: null,
  });
};

const validate = (): Promise<{ valid: boolean }> => {
  if (!formRef.value) return Promise.resolve({ valid: true });
  return formRef.value.validate();
};

defineExpose({ addSearchPropertyRow, validate });
</script>